define('lib/backbone/Backbone.PodioPaginatedCollectionView',['require','underscore','lib/backbone/Backbone.PodioCollectionView','jst!lib/paginated_collection/_list_wrapper','jst!lib/paginated_collection/_nav'],function(require) {

  var _ = require('underscore');
  var PodioCollectionView = require('lib/backbone/Backbone.PodioCollectionView');

  var jstListWrapper = require('jst!lib/paginated_collection/_list_wrapper');
  var jstNav = require('jst!lib/paginated_collection/_nav');

  return PodioCollectionView.extend({

    podioEvents : {
      'click .pagination-nav > .show-more' : 'onShowMoreButtonClicked'
    },

    constructor: function(options){
      PodioCollectionView.prototype.constructor.apply(this, _.toArray(arguments));

      this.pageSize = options.pageSize || 25;
    },

    renderCollection: function(options){
      var firstPageData;

      this._initListWrapper();

      if(this.reversedPagination) {
        firstPageData = _(this.collection.last(this.pageSize));
      } else {
        firstPageData = _(this.collection.first(this.pageSize));
      }

      this.renderItems(firstPageData);

    },

    _initListWrapper: function() {
      if(!this.elmListWrapper) {
        this.elmListWrapper = this.getTemplateAsElement(jstListWrapper);
        this.elmListWrapper.appendTo(this.elm);
      }
    },

    createAndAddChildView: function(item, index) {
      this._initListWrapper();
      var ItemView = this.getItemView(item);
      var renderedView = this.addItemView(item, ItemView, index);
      this.prependItem(renderedView, this.elmListWrapper);
    },

    renderItems: function(collection, options) {

      var ItemView;
      var renderedView;
      var shouldAppendItems = (options && 'appendItems' in options) ? options.appendItems : true;

      collection.each(function(item, index){

        ItemView = this.getItemView(item);
        renderedView = this.addItemView(item, ItemView, index);

        // Debugging index
        // var realIndex = this.collection.indexOf(item);
        // renderedView.elm.append(realIndex);

        if(shouldAppendItems) {
          this.appendItem(renderedView, this.elmListWrapper);
        } else {
          this.prependItem(renderedView, this.elmListWrapper);
        }
      }, this);

      this.renderPaginationNav();
    },

    renderPaginationNav: function() {

      var totalSize = this.collection.length;
      var renderedSize = this.children.length;

      if(totalSize > renderedSize) {

        if(this.elmPaginationNav) {
          this.elmPaginationNav.remove();
        }

        this.elmPaginationNav = this.getTemplateAsElement(jstNav, {
          pageSize: this.pageSize
        });

        if(this.reversedPagination) {
          this.elmPaginationNav.prependTo(this.elm);
        } else {
          this.elmPaginationNav.appendTo(this.elm);
        }

      } else {

        if(this.elmPaginationNav) {
          this.elmPaginationNav.remove();
        }

      }

    },

    onShowMoreButtonClicked: function(elmTarget, e) {

      e.stopPropagation();

      var renderedElementsSize = this.children.length;
      var nonRenderedItems;
      var pageData;

      if(this.reversedPagination) {
         nonRenderedItems = this.collection.models.slice(0, renderedElementsSize * -1);
         pageData = _.last(nonRenderedItems, this.pageSize).reverse();
      } else {
         nonRenderedItems = this.collection.models.slice(renderedElementsSize);
         pageData = _.first(nonRenderedItems, this.pageSize);
      }

      pageData = _(pageData);

      this.renderItems(pageData, {
        appendItems: this.reversedPagination ? false : true
      });

    }

  });

});

